/* Application names */
export const SBA_APPNAME_LABEL = "Application profile name";
export const SBA_SAVE_BUTTON = "Save";
export const APP_NAME_IS_DUPLICATED = " is already in use. Choose another name.";

/* Generic constants*/
export const CANCEL = "Cancel";
export const COPIED = "Copied";
export const COPY = "Copy";
export const GENERIC_ERROR = 'A problem occurred. Try again or contact Imprivata Customer Support.';
export const GENERIC_ERROR_PART1 = 'A problem occurred. Try again or contact';
export const GENERIC_ERROR_SUPPORT_URL = 'http://support.imprivata.com/';
export const GENERIC_ERROR_PART2 = 'Imprivata Customer Support.';

/* Launch errors */
export const LAUNCH_ERROR_INVALID_CONTEXT = "This page received an invalid launch request and cannot continue. Contact Imprivata Customer Support.";
export const LAUNCH_ERROR_SIGN_IN_FAILED = "Sign-in failed. Close this page and open it again from Applications.";
export const LAUNCH_ERROR_CONFIGURATION = "This appliance is not configured for the IdP. Contact Imprivata Customer Support.";
export const LAUNCH_ERROR_SESSION_EXPIRED = "Your session has expired. Close this page and open it again from Applications.";

/* OIDC */
export const OIDC_APPLICATION = "application using OpenID Connect";
export const OIDC_TITLE_ADD = "Add " + OIDC_APPLICATION;
export const OIDC_SUBTITLE = "Configure an OpenID Connect-based application for single sign-on.";
export const OIDC_URIS_TITLE = "Redirect URIs";
export const OIDC_URIS_SUBTITLE = "To redirect users to a given application, provide at least one URI.";
export const OIDC_ADD_URI = "Add URI";
export const OIDC_REMOVE_URI = "Remove URI";
export const OIDC_URI_PLACEHOLDER = "Enter your redirect URI here";
export const OIDC_URI_IS_DUPLICATED = "One or more duplicate redirect URIs.";
export const OIDC_CLIENT_CREDENTIALS = "Client credentials";
export const OIDC_CLIENT_ID = "Client ID";
export const OIDC_CLIENT_SECRET = "Client secret";
export const OIDC_GENERATE_CLIENT_CREDENTIALS = "Generate client credentials";
export const OIDC_REGENERATE_CLIENT_CREDENTIALS = "Regenerate client credentials";
export const OIDC_CLIENT_CREDENTIALS_REGENERATED = "The client credentials were rejected, so new ones were generated. Copy them and save again.";
export const OIDC_CLOUD_SERVER_FAILURE = "The application may have been created, but it could not be synchronized to the Imprivata appliance. Check Applications before trying again, or contact Imprivata Customer Support.";
export const OIDC_REQUEST_INSUFFICIENT_DATA = "Some required information is missing. Check the form and save again.";
export const OIDC_SCOPES_TITLE = "Scopes";
export const OIDC_PUBLIC_CLIENT_LABEL = 'Public client';
export const OIDC_PUBLIC_CLIENT_INFO = 'Public clients are less secure. Use with caution.';
